import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableDeductionType = QueryHookResult<
  typeof useDeductionsQuery
>[number];

export const useDeductionsQuery = createQueryHook(
  'trade.deductionTypes',
  (params: { ids?: string[]; searchTerm?: string }) => ({
    deductionTypes: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
      },
      entries: {
        id: true,
        name: true,
        applicationType: true,
      },
    },
  }),
  {
    select: (data) => data.deductionTypes.entries,
  },
);

export const SelectDeductionTypeTouch =
  createEntityTouchSelect.remotelySearched(
    'SelectDeductionType',
    useDeductionsQuery,
    {
      formatLabel: (entity) => entity.name,
    },
  );
